import { CartAddEvent } from '@theme/events';

async function psAddtoCart(data) {


    //Call Partstream App

    

  const variantId = '51397853872447';
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  });

  const addedItem = await res.json();

  // Fetch updated cart
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();

  // Fire the same event the theme uses
  document.dispatchEvent(new CartAddEvent(cart, 'my-button', {
    source: 'custom',
    productId: variantId,
    itemCount: cart.item_count,
  }));

    customElements.whenDefined('cart-drawer-component').then(() => {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) drawer.open(); // triggers showDialog() and slides in
    });
  
  
  
}

window.psAddtoCart = psAddtoCart;